export interface Vertex {
  x: number;
  y: number;
}

export interface Midpoint {
  x: number;
  y: number;
  /** Index at which to splice the new vertex (in the vertices array, not points array). */
  insertIndex: number;
}

export const pointsToVertices = (points: number[]): Vertex[] => {
  const result: Vertex[] = [];

  for (let i = 0; i + 1 < points.length; i += 2) {
    result.push({ x: points[i], y: points[i + 1] });
  }

  return result;
};

export const verticesToPoints = (vertices: Vertex[]): number[] => vertices.flatMap((v) => [v.x, v.y]);

/** Returns the midpoint between each pair of adjacent vertices (wrapping last→first). */
export const computeMidpoints = (vertices: Vertex[]): Midpoint[] =>
  vertices.map((v, i) => {
    const next = vertices[(i + 1) % vertices.length];
    return { x: (v.x + next.x) / 2, y: (v.y + next.y) / 2, insertIndex: i + 1 };
  });
